module.exports = __webpack_public_path__ + "media/rosalina-and-luma.6d9a5d2f.wav";